import { ElementHTML } from '@helpers/helper.rendering'
import React, { useEffect, useState } from 'react'
import { Col, Row } from 'react-bootstrap'
import ReCAPTCHA from 'react-google-recaptcha'
import toast from 'react-hot-toast'
import { RealEstateDataFooterData, RealEstateDataPage } from 'types'
import { useCreateFormMutation as useSendContactFormMutationMediacore } from '@apis/mediacore/contact'
import Image from '@components/Image'

interface ExternalProps {
  pages: RealEstateDataPage[]
  development_id: string
  property_id: string
  novelty_id: string
}

type CombinedProps = RealEstateDataFooterData & ExternalProps

const Footer14 = (props: CombinedProps) => {
  const [isMounted, setIsMounted] = useState(false)

  const {
    global_data,
    backgroundColor,
    titles,
    titleHexa,
    image_gatsby,
    image_bottom_gatsby,
    paragraphColor, //Color sucursales
    backgroundHexa, //Color fondo header
    button,
    items,
    socialMediaFooter,
  } = props

  const social = socialMediaFooter
  const captcha = global_data.pageConfig.keys.captcha
  const realEstateName = global_data.name

  const getCurrentYear = () => new Date().getFullYear()

  const [sendContactFormMediacore] = useSendContactFormMutationMediacore()

  const [disabled, setDisabled] = useState(true)
  const [data, setData] = useState({ email: '' })

  const [token, setValueToken] = useState('')

  function onChange(value: any) {
    setValueToken(value)
  }

  const sendForm = (e: { preventDefault: () => void }) => {
    e.preventDefault()
    const tags = ['Sitio Web', 'Newsletter', realEstateName]
    sendContactFormMediacore({
      data: { ...data, tags, token: token },
      type: 'newsletter',
      site: global_data.id,
    })
    ;(document.getElementById('formNewsletter') as HTMLFormElement)?.reset()
    return toast.success('Te suscribiste a nuestro newsletter correctamente.')
  }

  const handleInputChange = (e: { target: { name: string; value: string } }) => {
    setData({ ...data, [e.target.name]: e.target.value })
  }

  useEffect(() => {
    setIsMounted(true)
  }, [])

  const [isHover, setIsHover] = useState(false)

  const handleMouseEnter = () => {
    setIsHover(true)
  }
  const handleMouseLeave = () => {
    setIsHover(false)
  }

  return (
    isMounted && (
      <footer
        id="footer"
        style={{ color: titleHexa || '#fff' }}
        className="footer-10"
      >
        <div
          style={{ backgroundColor: backgroundColor }}
          className="w-100 d-flex justify-content-center"
        >
          {(() => {
            // Use image_bottom_gatsby on mobile if provided
            const isMobile = typeof window !== 'undefined' ? window.innerWidth < 992 : false
            const imageToUse = isMobile && image_bottom_gatsby ? image_bottom_gatsby : image_gatsby
            return (
              <Image
                alt="imagen-superior-footer"
                className="mx-auto d-block my-0 py-5"
                objectFit="contain"
                style={{ width: 'fit-content' }}
                objectPosition={'center'}
                image={imageToUse!}
              />
            )
          })()}
        </div>
        <Row
          style={{ backgroundColor: backgroundColor }}
          className="content text-lg-start text-center justify-content-center"
        >
          <Col
            xs={12}
            md={12}
            className="text-center align-items-center d-flex justify-content-center"
          >
            {social &&
              social.map((item, index) => (
                <a
                  key={index}
                  target="_blank"
                  className="d-flex align-items-center mx-3"
                  aria-label="Lea más en la red social"
                  href={item.link}
                >
                  <Image
                    alt={'social-link-' + index}
                    className=""
                    objectFit="contain"
                    objectPosition={'center'}
                    image={item.image_gatsby!}
                  />
                </a>
              ))}
          </Col>
          <Col
            md={12}
            className="d-lg-flex my-5 pt-5 justify-content-between text-center flex-wrap"
          >
            {titles?.branch_office && <h5>{titles?.branch_office}</h5>}
            {items?.map((suc, index) => (
              <div
                className="mx-lg-2 mb-4 mb-lg-0 text-center"
                key={index}
              >
                <p
                  className="bold text-uppercase"
                  style={{ color: paragraphColor || '#000' }}
                >
                  {suc.title}
                </p>
                <p
                  className="text-uppercase"
                  style={{ color: paragraphColor || '#000' }}
                >
                  {suc.subtitle}
                </p>
                <p style={{ color: paragraphColor || '#000' }}>{suc.paragraph}</p>
              </div>
            ))}
          </Col>
          <Col
            xs={12}
            md={{ span: 4, offset: 4 }}
            className="text-center justify-content-center"
          >
            <ElementHTML
              children={titles?.newsletter}
              elementType="h4"
              className="mb-3 mt-lg-5 title"
              style={{ color: titleHexa || '#fff' }}
            />
            <form
              onSubmit={sendForm}
              id="formNewsletter"
            >
              <div className="d-flex mx-auto justify-content-center mb-lg-3">
                <input
                  style={{
                    color: titleHexa || '#fff',
                    backgroundColor: backgroundHexa,
                    border: '1px solid ' + (button?.borderColor || '#000'),
                  }}
                  type="email"
                  onChange={handleInputChange}
                  name="email"
                  required
                  placeholder="Ingresá tu mail"
                  className={`mr-2`}
                />
                <button
                  onMouseEnter={handleMouseEnter}
                  onMouseLeave={handleMouseLeave}
                  style={{
                    backgroundColor: isHover ? button?.valueColor : button?.backgroundColor,
                    color: isHover ? button?.backgroundColor : button?.valueColor,
                  }}
                  disabled={disabled}
                  type="submit"
                  className={'icon-arrow'}
                  aria-label="Boton enviar formulario"
                ></button>
              </div>
              {captcha ? (
                <ReCAPTCHA
                  sitekey={captcha}
                  onChange={(value) => {
                    setDisabled(false)
                    onChange(value)
                  }}
                />
              ) : (
                ''
              )}
            </form>
          </Col>
          <Col
            xs={12}
            md={4}
            className="text-center align-items-center justify-content-center"
          >
            <ElementHTML
              children={titles?.global}
              elementType="h4"
              className="mb-3 mt-5 title"
              style={{ color: titleHexa || '#fff' }}
            />
          </Col>
          <Col
            xs={12}
            className="my-5 py-5"
          >
            <div
              className="separator"
              style={{ height: '1px', width: '100%', backgroundColor: '#c1c1c1' }}
            ></div>
          </Col>
          <Col
            xs={12}
            className="text-center justify-content-center d-lg-flex align-items-start mt-5 mt-lg-0"
          >
            <p
              style={{ color: titleHexa || '#fff' }}
              className="copy"
            >
              Promoted by{' '}
              <a
                target="_blank"
                style={{ color: '#00A1FF' }}
                className="normal-color"
                href={global_data.content.promoted_by?.link || 'https://mediahaus.com.ar'}
              >
                {' '}
                {global_data.content.promoted_by?.label || 'MediaHaus'}
              </a>{' '}
              - Powered by{' '}
              <a
                style={{ color: titleHexa || '#fff' }}
                target="_blank"
                href="https://mediacore.app/"
              >
                {' '}
                MediaCore
              </a>
              <br />
              <span
                style={{ color: titleHexa || '#fff' }}
                className="small-text white"
              >
                Todos los derechos reservados ® {getCurrentYear()}
              </span>
              <br />
              <span
                style={{ color: titleHexa || '#fff', opacity: '0.7' }}
                className="small-text light-white"
              >
                {process.env.GATSBY_COMMIT_HASH} {' - '} {process.env.GATSBY_GIT_TAG}{' '}
              </span>
            </p>
          </Col>
        </Row>
      </footer>
    )
  )
}

export default Footer14
